import { useState, useEffect, useRef } from "react";
import {
    Container,
    Card,
    Header,
    Input,
    Button,
    Footer,
    Alert,
} from "../Components/Auth/";
import { login } from "../Api/login";
import useAuth from "../Hooks/useAuth";
import { useNavigate } from "react-router-dom";

export const Login = () => {
    const navigate = useNavigate();
    const usernameRef = useRef(null);
    const passwordRef = useRef(null);

    const [username, setUsername] = useState(
        localStorage.getItem("username") || ""
    );
    const [password, setPassword] = useState(
        localStorage.getItem("password") || ""
    );
    const [error, setError] = useState({ message: "", type: null });
    const [alert, setAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const { setAuth } = useAuth();

    const validate = () => {
        setAlert(false);
        const usrRegex = /^[a-z0-9]{4,}$/;
        const pwRegex = /^[a-zA-Z0-9.*#@&]{4,}$/;

        if (!username) {
            setAlert(true);
            setError({ message: "Username tidak boleh kosong", type: 0 });
            return false;
        }
        if (!usrRegex.test(username)) {
            setAlert(true);
            setError({
                message:
                    "Username tidak boleh spasi, tidak < 4 huruf, tidak huruf kapital",
                type: 0,
            });
            return false;
        }
        if (!password) {
            setAlert(true);
            setError({ message: "Password tidak boleh kosong", type: 0 });
            return false;
        }
        if (!pwRegex.test(password)) {
            setAlert(true);
            setError({ message: "Password tidak boleh < 4 huruf", type: 0 });
            return false;
        }

        return true;
    };

    const submitData = async () => {
        if (!validate()) return;
        setLoading(true);

        try {
            let data = await login(username, password);

            if (data.success && data?.data) {
                setAlert(true);
                setError({ message: data.message, type: 1 });
                setAuth(data.data);

                localStorage.setItem("username", username);
                localStorage.setItem("password", password);

                setTimeout(() => navigate("/dashboard"), 2000);
            } else {
                setAlert(true);
                setError({ message: data.message, type: 0 });
            }
        } catch (error) {
            setAlert(true);
            setError({ message: "Client Error", type: 0 });
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        sessionStorage.removeItem("OGM1ZmVlMmZhZ==");
    }, []);

    return (
        <Container>
            <Card>
                <Header />
                {alert && <Alert message={error.message} type={error.type} />}
                <Input
                    label="Username"
                    type="text"
                    value={username}
                    ref={usernameRef}
                    onChange={(e) => setUsername(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") passwordRef.current?.focus();
                    }}
                />

                <Input
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    ref={passwordRef}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") submitData();
                    }}
                />

                <div
                    className="text-sm text-right px-2 text-blue-500 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}>
                    {showPassword
                        ? "Sembunyikan Password"
                        : "Tampilkan Password"}
                </div>

                <Button
                    label={loading ? "Loading..." : "Login"}
                    type="button"
                    onClick={submitData}
                    disabled={loading}
                />
                <Footer />
            </Card>
        </Container>
    );
};
